
import { computed, defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { useQuasar } from 'quasar'
import { CtCatalogue, CtCatalogueProduct } from '@/models/interfaces/content-type'
import TrashIcon from '@/components/Icons/TrashIcon.vue'

export default defineComponent({
  name: 'ChannelProductCard',
  props: {
    channelProduct: {
      type: Object as PropType<CtCatalogueProduct>,
      required: true,
    },
    productPrice: {
      type: Number,
      required: true,
    },
    channel: {
      type: Object as PropType<CtCatalogue>,
      required: false,
    },
    draft: {
      type: Boolean,
      default: false,
    },
    pendingRemoval: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      required: false,
    },
  },
  components: { TrashIcon },
  setup (props) {
    const $q = useQuasar()
    const $router = useRouter()

    const clickable = computed(() => Boolean(props.channel?.sys?.id?.length) && !props.editing)

    const onCardClick = () => {
      if (clickable.value) {
        $q.dialog({
          title: 'Go to channel page?',
          cancel: true,
          persistent: false
        }).onOk(
          () => void $router.push({ name: 'Channels', params: { channelId: props.channel?.sys?.id }, query: { fromProduct: props.channelProduct?.id } })
        )
      }
    }

    const pricing_manager_service = computed(() => {
      return props.channel?.service?.sync?.product?.pricing_manager_service
    })

    const currencySignDict = {
      'EUR': '€',
      'USD': '$',
      'BRL': 'R$'
    }

    const currencySign = computed(() => {
      const cat = props.channel as CtCatalogue & { currency: string }
      return currencySignDict[cat?.currency || 'EUR']
    })

    return {
      clickable,
      onCardClick,
      pricing_manager_service,
      currencySign
    }
  },
})
